import { Mail, Phone, Clock } from 'lucide-react';
import { SectionLabel, Reveal } from '../Section';
import SocialIcon from '../SocialIcon';
import EnquiryForm from '../EnquiryForm';

export default function Contact({ settings }) {
  const items = [
    settings?.contact_email_1 && { icon: Mail, label: 'Email', value: settings.contact_email_1, href: `mailto:${settings.contact_email_1}`, testid: 'contact-email-1' },
    settings?.contact_email_2 && { icon: Mail, label: 'Email (Alt)', value: settings.contact_email_2, href: `mailto:${settings.contact_email_2}`, testid: 'contact-email-2' },
    settings?.contact_phone_1 && { icon: Phone, label: 'Phone', value: settings.contact_phone_1, href: `tel:${settings.contact_phone_1}`, testid: 'contact-phone-1' },
    settings?.contact_phone_2 && { icon: Phone, label: 'Phone (Alt)', value: settings.contact_phone_2, href: `tel:${settings.contact_phone_2}`, testid: 'contact-phone-2' },
    settings?.whatsapp_url && { icon: null, social: 'whatsapp', label: 'WhatsApp', value: 'Chat with us on WhatsApp', href: settings.whatsapp_url, testid: 'contact-whatsapp' },
    settings?.support_hours && { icon: Clock, label: 'Support Hours', value: settings.support_hours, href: null, testid: 'contact-support-hours' },
  ].filter(Boolean);

  return (
    <section id="contact" className="py-20 sm:py-28" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionLabel testid="contact-label">Talk to KROY</SectionLabel>
        <Reveal>
          <h2 className="mt-5 font-display text-white text-3xl sm:text-5xl max-w-xl">
            Partnerships, support or just <span className="text-[#e8173a]">gg</span> — say hello
          </h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-10">
          {items.length > 0 && (
            <Reveal delay={0.05}>
              <div className="space-y-4" data-testid="contact-info-list">
                {items.map((item) => {
                  const IconEl = item.icon;
                  const inner = (
                    <>
                      <span className="w-11 h-11 rounded-lg bg-[#e8173a]/10 border border-[#e8173a]/25 flex items-center justify-center shrink-0 text-[#e8173a]">
                        {IconEl ? <IconEl className="w-5 h-5" strokeWidth={2.2} /> : <SocialIcon name={item.social} className="w-5 h-5" />}
                      </span>
                      <span className="min-w-0">
                        <span className="block text-[10px] font-bold uppercase tracking-[0.2em] text-[#8a8a8a]">{item.label}</span>
                        <span className="block mt-1 text-sm text-white font-medium break-all">{item.value}</span>
                      </span>
                    </>
                  );
                  const cls = 'card-surface card-surface-hover p-5 flex items-center gap-4';
                  return item.href ? (
                    <a
                      key={item.testid}
                      data-testid={item.testid}
                      href={item.href}
                      {...(item.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                      className={cls}
                    >
                      {inner}
                    </a>
                  ) : (
                    <div key={item.testid} data-testid={item.testid} className={cls}>
                      {inner}
                    </div>
                  );
                })}
              </div>
            </Reveal>
          )}
          <Reveal delay={0.12} className={items.length === 0 ? 'lg:col-span-2' : ''}>
            <EnquiryForm testidPrefix="contact-enquiry" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
